const routes = {
  external: {
    cancelDues: "https://act.dsausa.org/survey/dsa-payment-cancellation-form",
    changeChapter: "https://act.dsausa.org/survey/request_to_change_your_chapter/",
    membershipCard: "https://act.dsausa.org/survey/request_a_new_membership_card",
    refundPayment: "https://act.dsausa.org/survey/refund-payment",
    resources: "https://dsausa.org/resources/",
    proof: "https://proof.dsausa.org/",
    renew: "https://act.dsausa.org/donate/renew",
    requestDuesWaiver: "https://act.dsausa.org/survey/dueswaiver",
    support: "https://tickets.ntc.dsausa.org/",
  },
  internal: {
    base: "/",
    signup: "/signup",
    login: "/login",
    account: "/account",
    membership: "/membership",
    preferences: "/preferences",
    profile: "/profile",
    page_not_found: "/*",
  },
  unlisted: {
    error: "/error",
  },
} as const;

export default routes;
